goog.provide("shadow.js.shim.module$src$svg$person$person_3_svg");
goog.provide("module$shadow_js_shim_module$src$svg$person$person_3_svg");
shadow.js.shim.module$src$svg$person$person_3_svg = shadow.js.nativeProvides["src/svg/person/person-3.svg"] = shadow$bridge("src/svg/person/person-3.svg");
module$shadow_js_shim_module$src$svg$person$person_3_svg.default = shadow.js.shim.module$src$svg$person$person_3_svg;
